var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.950195C4.48598 0.950195 0 5.43617 0 10.9502C0 16.4642 4.48598 20.9502 10 20.9502C15.514 20.9502 20 16.4642 20 10.9502C20 5.43617 15.514 0.950195 10 0.950195ZM10 19.7737C5.13466 19.7737 1.17647 15.8155 1.17647 10.9502C1.17647 6.08485 5.13466 2.12667 10 2.12667C14.8653 2.12667 18.8235 6.08485 18.8235 10.9502C18.8235 15.8155 14.8653 19.7737 10 19.7737Z",
    fill: "#55A04B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5641 7.73131L9.37408 12.9212L6.71118 10.2585C6.48163 10.0287 6.10893 10.0287 5.87937 10.2585C5.64958 10.4882 5.64958 10.8607 5.87937 11.0903L8.9582 14.1691C9.07297 14.2839 9.22358 14.3414 9.3741 14.3414C9.52462 14.3414 9.67523 14.2839 9.79001 14.1691L15.3959 8.56313C15.6257 8.33345 15.6257 7.96098 15.3959 7.73131C15.1664 7.50155 14.7937 7.50155 14.5641 7.73131Z",
    fill: "#55A04B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.dc2970cafaec91b6bd8f37faa407eb86.svg";
export { ForwardRef as ReactComponent };